import {DataFetcher} from '@aboutyou/data-fetcher';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React, {useRef} from 'react';
import {useIsAuthenticated} from '../../features/Authentication/hooks/useIsAuthenticated';
import {useIsCoinsActive} from '../../features/Coins/utils/useIsCoinsActive';
import {useIsMissionsActive} from '../../features/Coins/utils/useIsMissionsActive';
import {CouponWallet} from '../../features/Coupons/CouponWallet/deprecated/CouponWallet';
import {WalletView} from './WalletView';
import {Wallet as DeprecatedWallet} from './deprecated/Wallet';
import {useActiveTab} from './utils/useActiveTab';
import {useGetWallet} from './utils/useGetWallet';
import {useWallet} from './utils/useWallet';

export interface WalletProps {
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
  setSelectedProduct?: (product: Product | undefined) => void;
}

export const Wallet: React.FC<WalletProps> = props => {
  const isCoinsActive = useIsCoinsActive();
  const isMissionsActive = useIsMissionsActive();
  const {activeTab} = useActiveTab();
  const {isOpen} = useWallet();
  const {isAuthenticated} = useIsAuthenticated();
  const isCoinsTabOpened = isCoinsActive && activeTab === 'coins' && isOpen;

  if (!isOpen) {
    return null;
  }

  if (!isCoinsActive) {
    // This is the old CouponWallet, needs to be removed once the Coins is fully rolled out
    return <CouponWallet {...props} />;
  }

  if (isCoinsTabOpened && !isAuthenticated) {
    return null;
  }

  if (!isMissionsActive) {
    // This is the old Wallet (Coins + Coupons), needs to be removed once the coins/missions is fully rolled out
    return <DeprecatedWallet {...props} />;
  }

  // Finally that's the new Wallet (Coins + Coupons + Notifications center)
  return <WalletFetcher {...props} />;
};

const WalletFetcher: React.FC<WalletProps> = props => {
  const request = useGetWallet();
  const shouldPreventAnimation = useRef(false);

  // Show loading skeleton when:
  // 1. No data yet and loading/idle
  // 2. Data is stale and refetching (e.g., after cache invalidation from mission completion)
  if (
    (!request.data && (request.isLoading || request.isIdle)) ||
    (request.isStale && request.isFetching)
  ) {
    shouldPreventAnimation.current = true;
    return <WalletView tabs={[]} {...props} />;
  }

  return (
    <DataFetcher
      request={request}
      Error={() => <WalletView requestError tabs={[]} {...props} />}
      Loading={() => <WalletView tabs={[]} {...props} />}
      View={WalletView}
      viewProps={{
        ...props,
        preventAnimation: shouldPreventAnimation.current,
      }}
    />
  );
};
